exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host > .text {\n  --height: 30px;\n  overflow: hidden;\n  height: var(--height);\n  padding: 0;\n  line-height: var(--height);\n  font-size: 15px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: #2b2b2b;\n  background-color: transparent;\n  cursor: var(--cursor);\n}\n:host > .text:not([disabled]) {\n  --cursor: auto;\n}\n:host > .text[disabled] {\n  --cursor: pointer;\n}\n:host > .text._is-active {\n  font-weight: 600;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/auto-focus-input/auto-focus-input.component.less
// module id = ../../../../../src/app/edit/sections-panel/auto-focus-input/auto-focus-input.component.less
// module chunks = main